(() => {
  const slugify = (value) => value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  const createElement = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };

  const getLead = (title, isEnglish) => {
    const key = title.toLocaleLowerCase();
    if (/confidential|privacy/.test(key)) {
      return isEnglish
        ? 'How we collect, use and protect your personal information when you visit or shop with us.'
        : 'Comment nous recueillons, utilisons et protégeons vos renseignements personnels lorsque vous visitez notre boutique ou effectuez un achat.';
    }
    if (/rembours|refund|return/.test(key)) {
      return isEnglish
        ? 'The conditions, steps and important information governing returns, exchanges and refunds.'
        : 'Les conditions, les étapes et les renseignements importants qui encadrent les retours, les échanges et les remboursements.';
    }
    if (/expédition|shipping|livraison/.test(key)) {
      return isEnglish
        ? 'Everything you need to know about order preparation, delivery, fees and parcel tracking.'
        : 'Tout ce qu’il faut savoir sur la préparation, la livraison, les frais et le suivi de votre colis.';
    }
    if (/condition|terms/.test(key)) {
      return isEnglish
        ? 'The terms that govern access to DIJA Store & CO, use of our services and purchases made through our store.'
        : 'Les conditions qui encadrent l’accès à DIJA Store & CO, l’utilisation de nos services et les achats effectués dans notre boutique.';
    }
    return isEnglish
      ? 'Official legal and business information for DIJA Store & CO, presented clearly and transparently.'
      : 'Les renseignements officiels, juridiques et commerciaux de DIJA Store & CO, présentés avec clarté et transparence.';
  };

  const enhanceNativePolicy = () => {
    const native = document.querySelector('.shopify-policy__container');
    if (!native || native.closest('[data-dija-policy]') || native.dataset.dijaNativeReady === 'true') return;
    native.dataset.dijaNativeReady = 'true';

    const titleNode = native.querySelector('.shopify-policy__title h1, h1');
    const body = native.querySelector('.shopify-policy__body') || native;
    if (!titleNode || !body) return;

    const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');
    const title = titleNode.textContent.trim();
    const labels = isEnglish
      ? {
          onPage: 'On this page', contents: 'Document contents', policies: 'Policies & information',
          otherPolicies: 'Other policies', helpTitle: 'Need clarification?',
          helpText: 'Our team can help you understand the information that applies to your order.',
          contact: 'Contact us', official: 'Official DIJA Store & CO document', print: 'Print',
          footerText: 'Questions about this document? Our team is available to assist you.',
          customerService: 'Contact customer service'
        }
      : {
          onPage: 'Sur cette page', contents: 'Sommaire du document', policies: 'Politiques et informations',
          otherPolicies: 'Autres politiques', helpTitle: 'Besoin d’une précision ?',
          helpText: 'Notre équipe peut vous aider à comprendre les renseignements applicables à votre commande.',
          contact: 'Nous contacter', official: 'Document officiel de DIJA Store & CO', print: 'Imprimer',
          footerText: 'Une question concernant ce document ? Notre équipe reste disponible pour vous accompagner.',
          customerService: 'Contacter le service à la clientèle'
        };

    const root = createElement('div', 'dija-policy');
    root.dataset.dijaPolicy = '';
    root.dataset.dijaNativePolicy = '';

    const hero = createElement('header', 'dija-policy__hero');
    const heroInner = createElement('div', 'page-width dija-policy__hero-inner');
    const heroCopy = createElement('div', 'dija-policy__hero-copy');
    heroCopy.append(
      createElement('p', 'dija-policy__eyebrow', 'DIJA STORE & CO'),
      createElement('h1', '', title),
      createElement('p', 'dija-policy__lead', getLead(title, isEnglish))
    );
    const heroMark = createElement('div', 'dija-policy__hero-mark');
    heroMark.setAttribute('aria-hidden', 'true');
    heroMark.append(createElement('span', '', 'DIJA'), createElement('small', '', 'STORE & CO'));
    heroInner.append(heroCopy, heroMark);
    hero.appendChild(heroInner);

    const layout = createElement('div', 'page-width dija-policy__layout');
    const side = createElement('aside', 'dija-policy__side');
    const tocGroup = createElement('div', 'dija-policy__side-group');
    tocGroup.dataset.policyTocWrap = '';
    tocGroup.appendChild(createElement('p', 'dija-policy__side-label', labels.onPage));
    const toc = createElement('nav', 'dija-policy__toc');
    toc.dataset.policyToc = '';
    toc.setAttribute('aria-label', labels.contents);
    tocGroup.appendChild(toc);
    side.appendChild(tocGroup);

    const footerPolicyLinks = [...document.querySelectorAll('.footer .policies a')];
    if (footerPolicyLinks.length) {
      const relatedGroup = createElement('div', 'dija-policy__side-group');
      relatedGroup.appendChild(createElement('p', 'dija-policy__side-label', labels.policies));
      const related = createElement('nav', 'dija-policy__related');
      related.setAttribute('aria-label', labels.otherPolicies);
      footerPolicyLinks.forEach((source) => {
        const link = createElement('a');
        link.href = source.href;
        if (new URL(source.href).pathname === window.location.pathname) link.setAttribute('aria-current', 'page');
        const arrow = createElement('i', '', '→');
        arrow.setAttribute('aria-hidden', 'true');
        link.append(createElement('span', '', source.textContent.trim()), arrow);
        related.appendChild(link);
      });
      relatedGroup.appendChild(related);
      side.appendChild(relatedGroup);
    }

    const contactSource = document.querySelector('.footer a[href*="/pages/contact"], a[href*="/pages/contactez-nous"]');
    const contactUrl = contactSource?.href || '/pages/contact';
    const help = createElement('div', 'dija-policy__help-card');
    const sparkle = createElement('span', '', '✦');
    sparkle.setAttribute('aria-hidden', 'true');
    const helpLink = createElement('a', '', labels.contact);
    helpLink.href = contactUrl;
    const helpArrow = createElement('span', '', '→');
    helpArrow.setAttribute('aria-hidden', 'true');
    helpLink.appendChild(helpArrow);
    help.append(sparkle, createElement('h2', '', labels.helpTitle), createElement('p', '', labels.helpText), helpLink);
    side.appendChild(help);

    const main = createElement('main', 'dija-policy__main');
    const documentCard = createElement('div', 'dija-policy__document');
    const documentBar = createElement('div', 'dija-policy__document-bar');
    const official = createElement('span');
    const check = createElement('i', '', '✓');
    check.setAttribute('aria-hidden', 'true');
    official.append(check, document.createTextNode(labels.official));
    const printButton = createElement('button');
    printButton.type = 'button';
    printButton.dataset.policyPrint = '';
    const printIcon = createElement('span', '', '↗');
    printIcon.setAttribute('aria-hidden', 'true');
    printButton.append(printIcon, document.createTextNode(labels.print));
    documentBar.append(official, printButton);

    const article = createElement('article', 'dija-policy__content rte');
    article.dataset.policyContent = '';
    while (body.firstChild) article.appendChild(body.firstChild);

    const documentFooter = createElement('footer', 'dija-policy__document-footer');
    const documentFooterLink = createElement('a', '', labels.customerService);
    documentFooterLink.href = contactUrl;
    const footerArrow = createElement('span', '', '→');
    footerArrow.setAttribute('aria-hidden', 'true');
    documentFooterLink.appendChild(footerArrow);
    documentFooter.append(createElement('p', '', labels.footerText), documentFooterLink);

    documentCard.append(documentBar, article, documentFooter);
    main.appendChild(documentCard);
    layout.append(side, main);
    root.append(hero, layout);
    native.replaceWith(root);
  };

  const initialise = () => {
    enhanceNativePolicy();

    document.querySelectorAll('[data-dija-policy]').forEach((page) => {
      if (page.dataset.policyReady === 'true') return;
      page.dataset.policyReady = 'true';

      const content = page.querySelector('[data-policy-content]');
      const toc = page.querySelector('[data-policy-toc]');
      const tocWrap = page.querySelector('[data-policy-toc-wrap]');
      if (!content || !toc) return;

      const usedIds = new Set();
      const headings = [...content.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim());
      headings.forEach((heading, index) => {
        let id = heading.id || slugify(heading.textContent) || `section-${index + 1}`;
        const baseId = id;
        let suffix = 2;
        while (usedIds.has(id) || document.getElementById(id)) {
          if (document.getElementById(id) === heading) break;
          id = `${baseId}-${suffix}`;
          suffix += 1;
        }
        heading.id = id;
        usedIds.add(id);

        const link = document.createElement('a');
        link.href = `#${id}`;
        link.className = heading.tagName === 'H3' ? 'is-subsection' : '';
        link.innerHTML = `<span>${String(index + 1).padStart(2, '0')}</span><strong></strong>`;
        link.querySelector('strong').textContent = heading.textContent.trim();
        toc.appendChild(link);
      });

      if (!headings.length && tocWrap) tocWrap.hidden = true;

      content.querySelectorAll('table').forEach((table) => {
        if (table.parentElement?.classList.contains('dija-policy__table-scroll')) return;
        const wrapper = createElement('div', 'dija-policy__table-scroll');
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      });

      page.querySelector('[data-policy-print]')?.addEventListener('click', () => window.print());
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', initialise);
})();
